export function getTokenTitelize(tokenKey: string = "") {
  const prefix = tokenKey.split(/[^a-zA-Z\s]+/)[0];
  const suffix = tokenKey.split(/[A-z-]+/).slice(-1)[0];
  return `${(prefix || "").toUpperCase()}-${suffix}`;
}
